import React from 'react';
import { TextVariant } from '@naf/text';
import { Accordion } from '@naf-simba/elements-accordion';
import { FAQGlobalReferenceType } from '@appTypes/FAQGlobalReferenceType';
import { useWindowLocation } from '@hooks/Window/useWindowLocation';
import SchemaFAQ from '@components/structured-data/SchemaFAQ';
import BlockContent from '../../../BlockContent';
import * as S from './FAQGlobalReference.styles';

interface FAQGlobalReferenceSerializerProps {
  value: FAQGlobalReferenceType;
}

export const FAQGlobalReference = ({ value }: FAQGlobalReferenceSerializerProps) => {
  const path = useWindowLocation();
  const { title, body, faqItems } = value;

  if (!value) return null;

  return (
    <S.FAQWrapper>
      {title && <S.FAQTitle variant={TextVariant.Header3}>{title}</S.FAQTitle>}
      {faqItems?.length &&
        faqItems.map((item) => (
          <Accordion headingLevel={3} key={item._id || item._key} title={item?.question} className="accordion">
            <S.AccordionContent>{item.answer && <BlockContent value={item.answer} />}</S.AccordionContent>
          </Accordion>
        ))}
      {body && (
        <S.BodyContentWrapper>
          <BlockContent value={body} />
        </S.BodyContentWrapper>
      )}
      <SchemaFAQ faq={value} url={path} />
    </S.FAQWrapper>
  );
};
